// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { __extends } from "tslib";
// THIS FILE WAS AUTOGENERATED
import { PageViewData } from "/druid/PageViewData";
/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    __extends(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(PageViewData));
export { PageViewPerfData };
//# sourceMappingURL=PageViewPerfData.js.map